/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plant_Extra_Real_Tree_For_EarthInputs */

const en_plant_extra_real_tree_for_earth = /** @type {(inputs: Plant_Extra_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plant for Earth Each Month`)
};

const ar_plant_extra_real_tree_for_earth = /** @type {(inputs: Plant_Extra_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ازرع من أجل الأرض كل شهر`)
};

const de_plant_extra_real_tree_for_earth = /** @type {(inputs: Plant_Extra_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pflanze für die Erde jeden Monat`)
};

const es_plant_extra_real_tree_for_earth = /** @type {(inputs: Plant_Extra_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planta por la Tierra cada mes`)
};

const fr_plant_extra_real_tree_for_earth = /** @type {(inputs: Plant_Extra_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantez pour la Terre chaque mois`)
};

const it_plant_extra_real_tree_for_earth = /** @type {(inputs: Plant_Extra_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pianta per la Terra ogni mese`)
};

const ja_plant_extra_real_tree_for_earth = /** @type {(inputs: Plant_Extra_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`毎月地球のために植樹`)
};

const ko_plant_extra_real_tree_for_earth = /** @type {(inputs: Plant_Extra_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`매달 지구를 위해 나무 심기`)
};

const pt_br_plant_extra_real_tree_for_earth = /** @type {(inputs: Plant_Extra_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plante para a Terra todo mês`)
};

const ru_plant_extra_real_tree_for_earth = /** @type {(inputs: Plant_Extra_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сажай деревья для Земли каждый месяц`)
};

const th_plant_extra_real_tree_for_earth = /** @type {(inputs: Plant_Extra_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลูกต้นไม้เพื่อโลกทุกเดือน`)
};

const tr_plant_extra_real_tree_for_earth = /** @type {(inputs: Plant_Extra_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her ay Dünya için bir ağaç dik`)
};

const zh_cn_plant_extra_real_tree_for_earth = /** @type {(inputs: Plant_Extra_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每月为地球种树`)
};

const zh_tw_plant_extra_real_tree_for_earth = /** @type {(inputs: Plant_Extra_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每月為地球種樹`)
};

/**
* | output |
* | --- |
* | "Plant for Earth Each Month" |
*
* @param {Plant_Extra_Real_Tree_For_EarthInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const plant_extra_real_tree_for_earth = /** @type {((inputs?: Plant_Extra_Real_Tree_For_EarthInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plant_Extra_Real_Tree_For_EarthInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plant_extra_real_tree_for_earth(inputs)
	if (locale === "ar") return ar_plant_extra_real_tree_for_earth(inputs)
	if (locale === "de") return de_plant_extra_real_tree_for_earth(inputs)
	if (locale === "es") return es_plant_extra_real_tree_for_earth(inputs)
	if (locale === "fr") return fr_plant_extra_real_tree_for_earth(inputs)
	if (locale === "it") return it_plant_extra_real_tree_for_earth(inputs)
	if (locale === "ja") return ja_plant_extra_real_tree_for_earth(inputs)
	if (locale === "ko") return ko_plant_extra_real_tree_for_earth(inputs)
	if (locale === "pt_br") return pt_br_plant_extra_real_tree_for_earth(inputs)
	if (locale === "ru") return ru_plant_extra_real_tree_for_earth(inputs)
	if (locale === "th") return th_plant_extra_real_tree_for_earth(inputs)
	if (locale === "tr") return tr_plant_extra_real_tree_for_earth(inputs)
	if (locale === "zh_cn") return zh_cn_plant_extra_real_tree_for_earth(inputs)
	return zh_tw_plant_extra_real_tree_for_earth(inputs)
});